import Cookies from "js-cookie";

const deleteWorkspaceKnowledge = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_WORKSPACE_KNOWLEDGE_FILES_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.delete(`/proxy/ai/workspaces/${data.workspaceId}/knowledge/${data.knowledgeId}?customer_id=${data.customer_id}&search=${data.search || ''}`, data);
        if (response && response.data.success) {
            commit('DELETE_WORKSPACE_KNOWLEDGE_FILE', payload.knowledgeId)
            dispatch("notifications/pushNotification", 'File Deleted', { root: true });
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_WORKSPACE_KNOWLEDGE_FILES_LOADING", false);
    }
};

export default deleteWorkspaceKnowledge;